'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  margin-right: 5px;\n'], ['\n  margin-right: 5px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  text-decoration: none;\n  color: black;\n\n  display: flex;\n  align-items: center;\n  font-size: ', 'px;\n  font-family: ', ';\n\n  &:hover {\n    color: ', ';\n    ', ' {\n      path {\n        stroke: ', ';\n      }\n    }\n  }\n'], ['\n  text-decoration: none;\n  color: black;\n\n  display: flex;\n  align-items: center;\n  font-size: ', 'px;\n  font-family: ', ';\n\n  &:hover {\n    color: ', ';\n    ', ' {\n      path {\n        stroke: ', ';\n      }\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _icons = require('../assets/icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Copyright = function Copyright(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === undefined ? 14 : _ref$size;
  return _react2.default.createElement(
    BuiltWith,
    {
      size: size,
      href: 'https://github.com/molefrog/presa',
      target: '_blank'
    },
    _react2.default.createElement(PresaIcon, { width: size * 1.3 }),
    _react2.default.createElement(
      'span',
      null,
      'Built with ',
      _react2.default.createElement(
        'strong',
        null,
        'Presa.'
      )
    )
  );
};

var PresaIcon = (0, _styledComponents2.default)(_icons.Presa)(_templateObject);

var BuiltWith = _styledComponents2.default.a(_templateObject2, function (props) {
  return props.size;
}, function (props) {
  return props.theme.monoFont;
}, function (props) {
  return props.theme.primaryColor;
}, PresaIcon, function (props) {
  return props.theme.primaryColor;
});

exports.default = Copyright;